/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/chat-exercise/v2.ts
 */

import { createValidator } from '../../helpers/validator';
export const ChatExerciseV2Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    question: {
      anyOf: [{
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['PureMultipleChoice'],
            default: 'PureMultipleChoice'
          },
          solutionItems: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                answer: {
                  type: 'string',
                  default: 'Wrong answer',
                  description: 'Possible answer choice.'
                },
                feedback: {
                  type: 'string',
                  default: 'Error message',
                  description: 'Feedback message for the submission. For the correct answer this is the success message.'
                },
                correct: {
                  type: 'boolean',
                  default: false,
                  description: 'Check a single box for the correct answer.'
                }
              },
              required: ['answer', 'feedback', 'correct']
            },
            description: 'List of possible answers. Use the arrows on the left-hand side to change the order, or the X to remove the item.'
          }
        },
        required: ['flavor', 'solutionItems'],
        title: 'SingleCorrectAnswer'
      }, {
        type: 'object',
        properties: {
          flavor: {
            type: 'string',
            enum: ['PureMultipleAnswers'],
            default: 'PureMultipleAnswers'
          },
          successMessage: {
            type: 'string',
            default: 'Well done!',
            description: 'Feedback message when the submission is correct.'
          },
          solutionItems: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                answer: {
                  type: 'string',
                  default: 'Wrong answer',
                  description: 'Possible answer choice.'
                },
                feedback: {
                  type: 'string',
                  default: 'Error message',
                  description: 'Feedback message when the submission is incorrect.'
                },
                correct: {
                  type: 'boolean',
                  default: false,
                  description: 'Check the box if the answer is correct.'
                }
              },
              required: ['answer', 'feedback', 'correct']
            },
            default: 'Well done!',
            description: 'List of possible answers. Use the arrows on the left-hand side to change the order, or the X to remove the item.'
          }
        },
        required: ['flavor', 'solutionItems', 'successMessage'],
        title: 'MultipleCorrectAnswers'
      }]
    },
    prompts: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          prompt: {
            type: 'string',
            default: 'A prompt',
            description: 'Possible prompt choice.'
          },
          response: {
            type: 'string',
            default: 'A response',
            description: 'The preset response for this prompt.'
          }
        },
        required: ['prompt', 'response']
      }
    },
    useSimulator: {
      type: 'boolean',
      title: 'Use Simulator',
      default: false,
      description: 'Enable/disable use of ChatGPT.'
    },
    customGptTitle: {
      type: 'string',
      title: 'Custom GPT Title',
      default: 'ChatGPT',
      description: 'The custom title of the GPT'
    },
    poweredBy: {
      anyOf: [{
        type: 'object',
        properties: {
          poweredByType: {
            type: 'string',
            enum: ['OpenAI'],
            default: 'OpenAI'
          }
        },
        required: ['poweredByType'],
        title: 'OpenAI'
      }, {
        type: 'object',
        properties: {
          poweredByType: {
            type: 'string',
            enum: ['Empty'],
            default: 'Empty'
          }
        },
        required: ['poweredByType'],
        title: 'Empty'
      }, {
        type: 'object',
        properties: {
          poweredByType: {
            type: 'string',
            enum: ['Custom'],
            default: 'Custom'
          },
          poweredByText: {
            type: 'string',
            default: '',
            description: 'Sets the custom powered by field'
          }
        },
        required: ['poweredByType', 'poweredByText'],
        title: 'Custom'
      }],
      title: 'Custom Powered By',
      description: 'The custom "powered by" text'
    },
    systemPrompt: {
      type: 'string',
      title: 'Custom System Prompt',
      default: '',
      description: 'The system prompt/instruction that should help guide the GPT'
    },
    iconUrl: {
      type: 'string',
      title: 'Custom Icon URL',
      description: 'The URL of the chat icon. Leave empty for default.',
      pattern: '(^$|^https://assets.datacamp.com/.*)'
    },
    assistantId: {
      type: 'string',
      title: 'Assistant ID',
      description: 'The assistant ID to which the files get uploaded. It should begin with `asst_`.',
      pattern: '^asst_.*'
    },
    solutionConversations: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          conversation: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                userPrompt: {
                  type: 'string',
                  title: 'User Prompt',
                  description: 'The user prompt.',
                  maxLength: 2000
                },
                aiResponse: {
                  type: 'string',
                  title: 'AI Response',
                  description: 'The AI response. This should be valid markdown. Keep in mind that less verbose content is more engaging.',
                  maxLength: 2000
                }
              },
              required: ['userPrompt', 'aiResponse']
            },
            title: 'Conversation',
            description: 'A single solution conversation.',
            minItems: 1
          }
        },
        required: ['conversation']
      },
      title: 'Solution Conversations',
      description: "The possible solution conversations. It's best to provide multiple conversations to show the variety of possible solutions. Up to 3 conversations possible.",
      minItems: 1,
      maxItems: 3
    }
  },
  required: ['assignment', 'chapter_id', 'course_id', 'customGptTitle', 'hint', 'poweredBy', 'prompts', 'question', 'solutionConversations', 'systemPrompt', 'title', 'xp'],
  definitions: {}
};
export const isValidChatExerciseV2 = createValidator(ChatExerciseV2Schema);
export const ChatExerciseV2Definition = {
  schema: ChatExerciseV2Schema,
  validate: isValidChatExerciseV2
};